import styled from "styled-components";

const H4 = styled.h4`
  margin-bottom: 0.5rem;
  font-family: ${props =>
    ["urban", "veilance"].includes(props.market.toLowerCase())
      ? '"Suisse Intl Regular", arial, sans-serif'
      : '"urw-din-condensed", arial, sans-serif'};
  font-size: ${props => (props.large ? "1.1rem" : "1rem")};
  font-weight: 700;
  line-height: 1.5rem;
  color: ${props => props.textColor};
  text-transform: uppercase;
`;

H4.defaultProps = {
  large: false,
  textColor: "#000",
  market: "outdoor",
};
export default H4;
